/**
 * @description Идентификатор состояния выбранных сотрудников для расчета заработной платы.
 * @type {string}
 */
export const SELECTED_EMPLOYEES = 'SELECTED_EMPLOYEES';

export default SELECTED_EMPLOYEES;
